import { Option } from "@fresh8/types/src/betData";

export function sortOptionsByOdds(
  a: Option | undefined,
  b: Option | undefined
): number {
  const aDecimals = (a?.odds[0] || 0) / (a?.odds[1] || 0) + 1;
  const bDecimals = (b?.odds[0] || 0) / (b?.odds[1] || 0) + 1;

  if (aDecimals < bDecimals) {
    return -1;
  }
  if (aDecimals > bDecimals) {
    return 1;
  }
  return 0;
}
